import React, { useEffect, useState } from "react";
import apiService from "../../../common/apiServices";
import HomeContactInfo from "../../Home/ContactInfo";
import CustomVideoPlayer from "../../Projects/videoPlayer";
import { useParams, useNavigate } from "react-router-dom";
import DetailsDescription from "./DetailsDescription";
import SoluAppBlock from "./SoluAppBlock";
import SolImplementation from "./SolImplemetation";
import DetailSolution from "./DetailSolution";
import { Box, Button, Typography } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
interface HomeContentProps {
  setLoading: (loading: boolean) => void;
}
const UpdatedSolutionDetails: React.FC<HomeContentProps> = ({ setLoading }) => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [sliderData, setSliderData] = useState<any>([]);
  const { type, id } = useParams();
  const [detailsData, setDetailsData] = useState<any>([]);
  const navigate = useNavigate();
  const activeTab = type === "storm" ? 0 : 1;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await apiService.fetchHomeDatas<any>("/api/solution");
        setSliderData(result);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await apiService.fetchHomeDatas<any>(
          `/api/solution/${type}/${id}`
        );
        setDetailsData(result?.data?.details);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const videoBanner = detailsData?.banners?.media?.length
    ? {
        url:
          process.env.REACT_APP_API_BASE_URL + detailsData.banners.media[0].url,
        mediaType: "video",
        thumbnail:
          process.env.REACT_APP_API_BASE_URL + detailsData.banners.media[0].url,
        type: "vertical",
      }
    : null;

  return (
    <>
      {videoBanner?.url && (
        <CustomVideoPlayer
          videoGallery={videoBanner}
          data-testid="custom-video-player"
        />
      )}
      <DetailsDescription pageData={detailsData} sliderData={sliderData} />
      <SoluAppBlock pageData={detailsData} />
      <DetailSolution pageData={detailsData} />
      <SolImplementation pageData={detailsData} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          my: 3,
          border: "none",
        }}
      >
        <Button
          className="sh-btn"
          sx={{ width: "max-content" }}
          onClick={() =>
            navigate(
              `/solutions/product-detail/${
                activeTab === 0 ? "storm" : "rain"
              }/${id}`
            )
          }
        >
          <Typography
            sx={{
              fontSize: {
                xs: "12px",
                sm: "16px",
                md: "16px",
                lg: "18px",
                xl: "18px",
              },
              fontWeight: 400,
            }}
          >
            Related Products
          </Typography>
          <ArrowDownwardIcon
            sx={{
              marginLeft: "8px",
              transform: "rotate(-150deg)",
              fontSize: "20px",
            }}
          />
        </Button>
      </Box>
      <HomeContactInfo />
    </>
  );
};

export default UpdatedSolutionDetails;
